import {
  CreateRecurringDonationPlanBody,
  RecurringDonationPlanResponse,
} from 'models/RecurringDonationPlan'

import { api } from '../api'

import { TransactionResponse, TransactionRequestBody } from 'models/Transaction'

export const recurringDonationPlansApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createRecurringDonationPlan: builder.mutation<
      RecurringDonationPlanResponse,
      CreateRecurringDonationPlanBody
    >({
      query: (createRecurringDonationPlanRequest) => ({
        method: 'POST',
        url: '/recurring-donation-plans',
        body: createRecurringDonationPlanRequest,
      }),
    }),
    createRecurringDonationPlanTransaction: builder.mutation<
      TransactionResponse,
      { recurringDonationPlanId: string; transaction: TransactionRequestBody }
    >({
      query: ({ recurringDonationPlanId, transaction }) => ({
        method: 'POST',
        url: `recurring-donation-plans/${recurringDonationPlanId}/transactions`,
        body: transaction,
      }),
    }),
  }),
})

export const {
  useCreateRecurringDonationPlanMutation,
  useCreateRecurringDonationPlanTransactionMutation,
  endpoints: { createRecurringDonationPlan, createRecurringDonationPlanTransaction },
} = recurringDonationPlansApi
